module.exports = __webpack_public_path__ + "assets/livanto-alt.abd3f8a9.svg";